import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchMillDispatchReceive,
    getMillDispatch,
} from '../../app/reducers/MillDispatch/millDispatchSlice';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import ViewMillReceivePoDataModal from './ViewMillReceivePoDataModal';
import { Trash } from 'react-feather';
import { deleteMillReceive } from '../../app/api/millReceive';

const ViewMillReceive = () => {
    const [page, setPage] = useState(1);
    const [poDetailData, setPoDetailData] = useState(null);
    const [isPoDataModalOpen, setIsPoDataModalOpen] = useState(false);
    const { millDispatch, loading } = useSelector(getMillDispatch);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchMillDispatchReceive({ populate: true }));
    }, []);

    const columns = [
        {
            Header: 'Invoice',
            accessor: 'invoiceNo',
        },
        {
            Header: 'Zoho Error',
            accessor: 'zohoError',
        },
        {
            Header: 'Vendor Name',
            accessor: 'vendorName',
        },
        {
            Header: 'Final Amount',
            accessor: 'finalAmount',
        },
        {
            Header: 'Amount Before Tax',
            accessor: 'amountBeforeTax',
        },
        {
            Header: 'Discount',
            accessor: 'discount',
        },
        {
            Header: 'tax',
            accessor: 'tax',
        },
        {
            Header: 'tds Value',
            accessor: 'tdsValue',
        },
        {
            Header: 'adjustment',
            accessor: 'adjustment',
        },
        {
            Header: 'notes',
            accessor: 'notes',
        },

        {
            Header: 'Po Detail',
            Cell: ({ row }) => {
                return (
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPoDataModalOpen(true);
                            setPoDetailData(row?.original);
                        }}
                        className="flex gap-2"
                    >
                        <Trash
                            color="red"
                            onClick={async () => {
                                await deleteMillReceive(row.original._id);
                            }}
                        />
                        <span className="text text-blue-400 hover:text-blue-700 cursor-pointer truncate">
                            View PO Data
                        </span>
                    </div>
                );
            },
        },
    ];

    const dataMemo = useMemo(
        () => (millDispatch?.docs ? millDispatch?.docs : []),
        [millDispatch]
    );

    const colsMemo = useMemo(() => columns ?? [], [columns]);

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            dispatch(
                fetchMillDispatchReceive({
                    search: search,
                    populate: true,
                    page,
                })
            );
        }, 300),
        []
    );

    return (
        <PageWithCard>
            <ViewMillReceivePoDataModal
                modalOpen={isPoDataModalOpen}
                setModalOpen={setIsPoDataModalOpen}
                data={poDetailData}
            />
            <TableWithHeadingAndGlobalSearch
                loading={loading}
                data={dataMemo}
                columns={colsMemo}
                heading={'View Mill Receive'}
                searchFunction={(search) => {
                    debouncedSearch(search);
                }}
            />
            <PaginationClassic
                paginationDetails={millDispatch}
                setPage={setPage}
            />
        </PageWithCard>
    );
};

export default ViewMillReceive;
